<template>
    <!-- PC -->
    <div v-if="!mobile">
        <div>
            <div class="lkt-manual env_VN">
                <div>
                    <ul>
                        <li @click="scrollToElement('vn-1')">コースを開始する</li>
                        <li @click="scrollToElement('vn-2')">コースを選択する</li>
                        <li @click="scrollToElement('vn-3')">コンテンツを上下に移動する</li>
                        <li @click="scrollToElement('vn-4')">ズームイン/ズームアウト</li>
                        <li @click="scrollToElement('vn-5')">全画面表示</li>
                        <li @click="scrollToElement('vn-6')">メモ</li>
                        <li @click="scrollToElement('vn-7')">コメント</li>
                        <li @click="scrollToElement('vn-8')">ページの遷移</li>
                        <li @click="scrollToElement('vn-9')">小テスト</li>
                        <li @click="scrollToElement('vn-10')">小テストの得点を表示する</li>
                        <li @click="scrollToElement('vn-11')">戻る</li>
                    </ul>
                </div>
                <div id="vn-1">
                    <h1>1. コースを開始する</h1>
                </div>
                <div>
                    <p>① 受講したいコースを選択します。</p>
                </div>
                <div><img src="/static\images\ja\newManual\lesson_content_1.png" alt="" /></div>
                <div>
                    <p>※ 受講したいコースをクリックし、コースの概要画面に移動します。</p>
                    <p>② コース概要画面で[開始]ボタンを押し、[コースカタログ]画面に移動します。</p>
                </div>
                <div><img src="/static\images\ja\newManual\lesson_content_2.png" alt="" /></div>
                <div id="vn-2">
                    <h1>2. コースを選択する</h1>
                </div>
                <div>
                    <p>① コースのメニューをクリックし、その内容を受講する。</p>
                    <p>※黒色：未学習　赤色：学習中　緑色：学習済</p>
                </div>
                <div><img src="/static\images\ja\newManual\lesson_content_3.png" alt="" /></div>
                <div id="vn-3">
                    <h1>3. コンテンツを上下に移動する</h1>
                </div>
                <div>
                    <p>※ コンテンツ内容は一ページに表示されない場合、右のバーを選択して上下に移動して内容を見えます。</p>
                </div>
                <div><img src="/static\images\ja\newManual\lesson_content_4.png" alt="" /></div>
                <div id="vn-4">
                    <h1>4. ズームイン/ズームアウト</h1>
                </div>
                <div>
                    <p>※ 画像情報がはっきりと見えない場合は、上のアイコンでズームインまたはズームアウトすることができます。</p>
                </div>
                <div><img src="/static\images\ja\newManual\lesson_content_5.png" alt="" /></div>
                <div id="vn-5">
                    <h1>5. 全画面表示</h1>
                </div>
                <div>
                    <p>「<<」ボタンをクリックすると、目次が隠され、コンテンツは全画面に広げて表示されます。又は「>>」ボタンにて全画面表示モードを解除し、通常の表示モードに戻ります。</p>
                </div>
                <div><img src="/static\images\ja\newManual\lesson_content_5.5.png" alt="" /></div>

                <div id="vn-6">
                    <h1>6. メモ</h1>
                </div>
                <div>
                    <p>① メモタブを選択します。</p>
                </div>
                <div><img src="/static\images\ja\newManual\lesson_content_6.png" alt="" /></div>
                <div>
                    <p>② 目次単位に必要に応じてメモを登録します。</p>
                    <p>③ [保存]ボタンを押します。</p>
                </div>
                <div><img src="/static\images\ja\newManual\lesson_content_7.png" alt="" /></div>
                <div id="vn-7">
                    <h1>7. コメント</h1>
                </div>
                <div>
                    <p>① コメントタブを選択します。</p>
                </div>
                <div><img src="/static\images\ja\newManual\lesson_content_8.png" alt="" /></div>
                <div>
                    <p>② ここでは、コースに関する質問を先生に提出することができます。</p>
                    <p>※ 先生方に質問を送るほか、他の生徒の交流の内容も見ることができます。</p>
                </div>
                <div><img src="/static\images\ja\newManual\lesson_content_9.png" alt="" /></div>
                <div id="vn-8">
                    <h1>8. ページの遷移</h1>
                </div>
                <div>
                    <p>※ [次へ]ボタンを押して、次のページに移動できる。[前へ]ボタンを押して、前のページに戻ります。</p>
                </div>
                <div><img src="/static\images\ja\newManual\lesson_content_10.png" alt="" /></div>
                <div id="vn-9">
                    <h1>9. 小テスト</h1>
                </div>
                <div>
                    <p>※ コースの練習を行うには、コースの全内容を受講する必要があります。コース内容が完了していない場合は、[小テスト]アイコンをクリックすると、警告ダイアログが表示されます。</p>
                    <p>① 各章節の「小テスト」欄に「小テスト」アイコンが表示されます。小テストアイコンを押すと、小テスト画面に移動します。</p>
                </div>
                <div><img src="/static\images\ja\newManual\lesson_content_11.png" alt="" /></div>
                <div>
                    <p>② 画面の右上にある小テストアイコンをクリックして、小テスト画面に移動します。</p>
                    <p>※ 該当章節に小テストがない場合、小テストアイコンは表示されないです。</p>
                </div>
                <div><img src="/static\images\ja\newManual\lesson_content_12.png" alt="" /></div>
                <div>
                    <p>③ 答え内容は確定ではない場合、[再確認] ラジオボタンを選択肢ボ、該当問題を再確認必要問題一覧に追加される</p>
                    <p>④ 質問に対する正解を選択します。</p>
                    <p>⑤ [前へ]を押すか、[次へ]を押して次の文を移動するか、前の質問に戻ります。</p>
                    <p>⑥ 質問番号の一覧を表示する。赤い枠線の付いた問題は、今やっているものです。青い問題は、あなたが選択した問題です。</p>
                    <p>⑦ 再確認必要問題一覧を表示します。</p>
                    <p>⑧ [表示モード変更]ボタンを押すと、質問表示モードの変更ができます。</p>
                    <p>⑨ [提出]ボタンを押して答え内容を提出します。</p>
                </div>
                <div><img src="/static\images\ja\newManual\lesson_content_13.png" alt="" /></div>
                <div id="vn-10">
                    <h1>10. 小テストの得点を表示する</h1>
                </div>
                <div>
                    <p>※ 小テストを提出後</p>
                    <p>得点率があります。緑色：小テストを採点され、合格しています。</p>
                    <p>得点率があります。赤色：小テストを採点され、合格していません。</p>
                    <p>得点率がありません。オレンジ色：小テストは提出しましたが、採点を待っています。</p>
                    <p>小テストアイコンが黒色の場合、小テストを受けていないか、または小テストを受けていますが、答えはまだ提出していないです。</p>
                    <p>① 小テストの答えを確認するには、対応する得点率欄の得点率[%]をクリックします。</p>
                </div>
                <div><img src="/static\images\ja\newManual\lesson_content_14.png" alt="" /></div>
                <div>
                    <p>② 緑の問題は正解です。オレンジの問題は不正解です。受講者は質問番号をクリックして問題内容と回答の詳細を表示できます。「次へ」と「前へ」ボタンをクリックすると全問題と次問題の詳細内を確認できる。</p>
                </div>
                <div><img src="/static\images\ja\newManual\lesson_content_15.png" alt="" /></div>
                <div id="vn-11">
                    <h1>11. 戻る</h1>
                </div>
                <div>
                    <p>※ ボタンをクリックして、コース目次画面に戻れます。</p>
                </div>
                <div><img src="/static\images\ja\newManual\lesson_content_16.png" alt="" /></div>
            </div>
        </div>
    </div>
    <!-- Mobile -->
    <div v-else>
        <div>
            <div class="lkt-manual env_VN">
                <div>
                    <ul>
                        <li @click="scrollToElement('vn-1')">コースを開始する</li>
                        <li @click="scrollToElement('vn-2')">コースを選択する</li>
                        <li @click="scrollToElement('vn-3')">コンテンツを上下に移動する</li>
                        <li @click="scrollToElement('vn-4')">ズームイン/ズームアウト</li>
                        <li @click="scrollToElement('vn-5')">メモ</li>
                        <li @click="scrollToElement('vn-6')">コメント</li>
                        <li @click="scrollToElement('vn-7')">ページの遷移</li>
                        <li @click="scrollToElement('vn-8')">小テスト</li>
                        <li @click="scrollToElement('vn-9')">小テストの得点を表示する</li>
                        <li @click="scrollToElement('vn-10')">戻る</li>
                    </ul>
                </div>
                <div id="vn-1">
                    <h1>1. コースを開始する</h1>
                </div>
                <div>
                    <p>① 受講したいコースを選択します。</p>
                </div>
                <div><img src="/static\images\ja\newManual\mobile\lesson_content_mb_1.png" alt="" /></div>
                <div>
                    <p>※ 受講したいコースをクリックし、コースの概要画面に移動します。</p>
                    <p>② コース概要画面で[開始]ボタンを押し、[コースカタログ]画面に移動します。</p>
                </div>
                <div><img src="/static\images\ja\newManual\mobile\lesson_content_mb_2.png" alt="" /></div>
                <div id="vn-2">
                    <h1>2. コースを選択する</h1>
                </div>
                <div>
                    <p>① コースのメニューをクリックし、その内容を受講する。</p>
                    <p>※ 黒色：未学習　赤色：学習中　青色：学習済</p>
                </div>
                <div><img src="/static\images\ja\newManual\mobile\lesson_content_mb_3.png" alt="" /></div>
                <div id="vn-3">
                    <h1>3. コンテンツを上下に移動する</h1>
                </div>
                <div>
                    <p>※ コンテンツ内容は一ページに表示されない場合、右のバーを選択して上下に移動して内容を見えます。</p>
                </div>
                <div><img src="/static\images\ja\newManual\mobile\lesson_content_mb_4.png" alt="" /></div>
                <div id="vn-4">
                    <h1>4. ズームイン/ズームアウト</h1>
                </div>
                <div>
                    <p>※ 画像情報がはっきりと見えない場合は、上のアイコンでズームインまたはズームアウトすることができます。</p>
                </div>
                <div><img src="/static\images\ja\newManual\mobile\lesson_content_mb_16.png" alt="" /></div>
                <div id="vn-5">
                    <h1>5. メモ</h1>
                </div>
                <div>
                    <p>① メモタブを選択します。</p>
                </div>
                <div><img src="/static\images\ja\newManual\mobile\lesson_content_mb_5.png" alt="" /></div>
                <div>
                    <p>② メモ内容を記入する。</p>
                </div>
                <div><img src="/static\images\ja\newManual\mobile\lesson_content_mb_6.png" alt="" /></div>
                <div>
                    <p>③ メモする内容を入力します。</p>
                    <p>④ [保存]ボタンを押します。</p>
                </div>
                <div><img src="/static\images\ja\newManual\mobile\lesson_content_mb_7.png" alt="" /></div>
                <div id="vn-6">
                    <h1>6. コメント</h1>
                </div>
                <div>
                    <p>① 画面下のメニューバーにある[目次]アイコンをクリックします。</p>
                </div>
                <div><img src="/static\images\ja\newManual\mobile\lesson_content_mb_5.png" alt="" /></div>
                <div>
                    <p>② コメントタブを選択します。</p>
                </div>
                <div><img src="/static\images\ja\newManual\mobile\lesson_content_mb_8.png" alt="" /></div>
                <div>
                    <p>③ ここでは、コースに関する質問を先生に提出することができます。</p>
                    <p>※ 先生方に質問を送るほか、他の生徒の交流の内容も見ることができます。</p>
                </div>
                <div><img src="/static\images\ja\newManual\mobile\lesson_content_mb_9.png" alt="" /></div>
                <div id="vn-7">
                    <h1>7. ページの遷移</h1>
                </div>
                <div>
                    <p>※ [進む]ボタンを押して、次のページに移動するか、前のページに戻ります。</p>
                </div>
                <div><img src="/static\images\ja\newManual\mobile\lesson_content_mb_17.png" alt="" /></div>
                <div id="vn-8">
                    <h1>8. 小テスト</h1>
                </div>
                <div>
                    <p>※ コースの練習を行うには、コースの全内容を受講する必要があります。コース内容が完了していない場合は、[小テスト]アイコンをクリックすると、警告ダイアログボックスが表示されます。</p>
                    <p>① 各章節の「小テスト」欄に「小テスト」アイコンが表示されます。小テストアイコンを押すと、小テスト画面に移動します。</p>
                </div>
                <div><img src="/static\images\ja\newManual\mobile\lesson_content_mb_11.png" alt="" /></div>
                <div>
                    <p>② 画面の右上にある小テストアイコンをクリックして、小テスト画面に移動します。</p>
                    <p>※ 該当章節に小テストがない場合、小テストアイコンは表示されないです。</p>
                </div>
                <div><img src="/static\images\ja\newManual\mobile\lesson_content_mb_12.png" alt="" /></div>
                <div>
                    <p>③ 答え内容は確定ではない場合、[再確認] ボタンをクリックし、該当問題を再確認必要問題一覧に追加する</p>
                    <p>④ 質問に対する正解を選択します。</p>
                    <p>⑤ [前へ]を押すか、[次へ]を押して次の文を移動するか、前の質問に戻ります。</p>
                    <p>⑥ 質問の一覧を表示する。赤い枠線の付いた問題は、今やっているものです。青い問題は、あなたが選択した問題です。</p>
                    <p>⑦ 再確認必要問題一覧を表示します。</p>
                    <p>⑧ [表示モード変更]ボタンを押すと、質問全体が表示されます。</p>
                    <p>⑨ [提出]ボタンを押して答え内容を提出します。</p>
                </div>
                <div><img src="/static\images\ja\newManual\mobile\lesson_content_mb_13.png" alt="" /></div>
                <div id="vn-9">
                    <h1>9. 小テストの得点を表示する</h1>
                </div>
                <div>
                    <p>※ 小テストを提出後の場合</p>
                    <p>得点率があります。緑色：小テストを採点され、合格しています。</p>
                    <p>得点率があります。赤色：小テストを採点され、合格していません。</p>
                    <p>得点率がありません。赤色：小テストは提出しましたが、採点を待っています。</p>
                    <p>小テストアイコンが黒色の場合、小テストを受けていないか、または小テストを受けていますが、答えはまだ提出していないです。</p>
                    <p>① 小テストの答えを確認するには、対応する得点率欄の得点率[%]をクリックします。</p>
                </div>
                <div><img src="/static\images\ja\newManual\mobile\lesson_content_mb_14.png" alt="" /></div>
                <div>
                    <p>② 緑の問題は正解です。オレンジの問題は不正解です。受講者は質問番号をクリックして問題内容と回答の詳細を表示できます。「次へ」と「前へ」ボタンをクリックすると全問題と次問題の詳細内を確認できる。</p>
                </div>
                <div><img src="/static\images\ja\newManual\mobile\lesson_content_mb_18.png" alt="" /></div>
                <div id="vn-10">
                    <h1>10. 戻る</h1>
                </div>
                <div>
                    <p>※ コース目次画面に戻るには戻るボタンをクリックします。</p>
                </div>
                <div><img src="/static\images\ja\newManual\mobile\lesson_content_mb_15.png" alt="" /></div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {};
        },
        components: {},
        computed: {
            mobile() {
                return this.$store.getters["header/mobile"];
            },
        },
        async created() {},
        watch: {},
        methods: {
            scrollToElement(id) {
                let element = document.getElementById(id);
                element.scrollIntoView();
            },
        },
    };
</script>
<style scoped>
    .lkt-manual div {
        margin-bottom: 10px;
    }
    .lkt-manual p {
        line-height: 25px;
    }
    .lkt-manual ul {
        margin-left: 20px;
        list-style: square;
        font-size: 12pt;
    }
    ul li {
        cursor: pointer;
    }
    img {
        width: 100%;
    }
    p {
        font-size: 16px;
    }
</style>



// WEBPACK FOOTER //
// src/components/manual/content/ja/lessonContent_manual.vue